import React, { Component } from "react";
import ErrorAccordion from "./ErrorAccordion";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: "",
    };
  }
  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      error: error.toString(),
    };
  }
  render() {
    if (this.state.hasError) {
      console.log("----ERROR----", this.state.error);
      return (
        <div>
          <h1 style={{ textAlign: "center", marginTop: "10%" }}>
            Something went wrong
          </h1>
          <ErrorAccordion ERROR={this.state.error} />
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
